import React from 'react';

import { type ProductKeys } from '../../../../common/constants/products';
import { EventTypeMessage, VIEWED_EVENT } from '../../../../common/ui/event-type-message';
import { ProductIcon } from '../../../../common/ui/product-icon';
import { SearchResult } from '../../../../common/ui/quick-find/search-dialog-result';

type BrowserHistoryItem = {
	id: string;
	type: 'browser-history';
	data: {
		productKey: ProductKeys;
		lastVisitTime: number;
		title: string;
		url: string;
	};
};

type BrowserHistoryProps = {
	result: BrowserHistoryItem;
};

export const BrowserHistory = ({ result }: BrowserHistoryProps) => {
	const { data } = result;
	const icon = <ProductIcon size="small" product={data.productKey} />;
	const rightMetadata = (
		<EventTypeMessage
			timestamp={new Date(data.lastVisitTime).toISOString()}
			eventType={VIEWED_EVENT.VIEWED}
			isMyActivityData={true}
		/>
	);
	return (
		<SearchResult
			id={result.id}
			icon={icon}
			title={data.title}
			resultType="historyActivities"
			product={data.productKey}
			url={data.url}
			rightMetadata={rightMetadata}
		/>
	);
};
